import angular from 'angular';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxAssignmentTemplateTypeahead', [
  '$http',
  'appUrls',
  '$translate',
  'translateListFilter',
  '$q',
  function($http, appUrls, $translate, translateListFilter, $q) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div class="dropdown" uib-dropdown ng-show="options.length" is-open="ddwOpen">' +
        ' <div class="input-group">' +
        '     <input type="text" ng-model="selected" uib-typeahead="item as item.label for item in options | filter:$viewValue | orderBy:[\'+label\']" typeahead-min-length="0" typeahead-select-on-blur="selectOnBlur" typeahead-select-on-exact="selectOnExact" typeahead-on-select="onSelect($item)" ng-blur="onBlur()" ng-focus="ddwOpen=false" class="form-control" placeholder="{{placeholder}}" autocomplete="off"/>' +
        '     <span class="input-group-btn">' +
        '         <button class="btn btn-default btn-font-14 dropdown-toggle" uib-dropdown-toggle ng-if="!selected.id">' +
        '             <span class="caret"></span>' +
        '         </button>' +
        '         <button class="btn btn-default btn-font-14" ng-if="selected.id" ng-click="onSelect(null)">' +
        '             <span class="fa fa-times"></span>' +
        '         </button>' +
        '     </span>' +
        ' </div>' +
        ' <ul class="dropdown-menu dropdown-menu-right" role="menu" style="max-height:200px;overflow-y:auto">' +
        '     <li ng-show="showDefaultAssignment" ng-class="{\'active\':selected===defaultAssignment}"><a href ng-click="onSelect(defaultAssignment)" data-translate="DefaultAssignment"></a></li>' +
        '     <li ng-show="showDefaultAssignment" role="separator" class="divider"></li>' +
        '     <li ng-repeat="op in options | orderBy:[\'label\']" ng-class="{\'selected\':op===selected}"><a href ng-click="onSelect(op)">{{op.label}}</a></li>' +
        ' </ul>' +
        '</div>',
      scope: {
        placeholder: '@?',
        showDefaultAssignment: '@?',
      },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        $scope.defaultAssignment = $scope.showDefaultAssignment
          ? {
              id: guid.empty,
              label: $translate.instant('DefaultAssignment'),
            }
          : null;
        var deferred = $q.defer();
        $http
          .get(`${appUrls.api}/api/AssignmentTemplate/Get`, {
            timeout: deferred.promise,
            cancel: deferred,
          })
          .then(({ data }) => {
            $scope.options = data
              .map(x => ({
                ...x,
                label: translateListFilter(x.id, 'assignmenttemplate', x.name),
              }))
              .sort(dynamicSort('label'));
            if ($scope.value && !$scope.selected) {
              $scope.selected = findOption($scope.value);
            }
          });

        $scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
          ? $scope.$eval(attrs.selectOnBlur) || attrs.selectOnBlur
          : true;
        $scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
          ? $scope.$eval(attrs.selectOnExact) || attrs.selectOnExact
          : true;

        var findOption = function(id) {
          if (id == null || $scope.options.length === 0) return null;

          if (id === guid.empty) {
            return $scope.defaultAssignment;
          }

          return $scope.options.find(function(el) {
            return el.id === id;
          });
        };

        $scope.onSelect = function(item) {
          if (item !== null) {
            $scope.selected = item;
            $scope.value = item.id;
            ngModel.$setViewValue(item.id);
          } else {
            $scope.value = null;
            $scope.selected = null;
            ngModel.$setViewValue(null);
          }
        };
        $scope.onBlur = function() {
          if ($scope.selected != null && $scope.selected.id != null) return;
          $scope.value = null;
          $scope.selected = null;
          ngModel.$setViewValue(null);
        };

        ngModel.$render = function() {
          $scope.value = ngModel.$viewValue;
          if ($scope.options) $scope.selected = findOption($scope.value);
        };
      },
    };
  },
]);
